import React, {
  useCallback, useContext, useState
} from 'react';
import { useNavigate } from 'react-router-dom';

import {
  AssetDistributionOption, ButtonBar, ScreenHeader
} from '../../components';
import { useScrollToTop } from '../../hooks';

import { NewPOAContext } from './new-poa-composer';

export function NewPOAGovernmentBenefits() {
  const { powerOfAttorney, setPowerOfAttorney } = useContext(NewPOAContext);
  const navigate = useNavigate();
  const [ governmentBenefits, setGovernmentBenefits ] = useState(powerOfAttorney.government_benefits || false);
  
  useScrollToTop();
  
  const handleBack = useCallback(() => {
    navigate('../pet-care');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    setPowerOfAttorney(prev => ({ 
      ...prev, 
      government_benefits: governmentBenefits
    }));
    navigate('../gifts-intro');
  }, [ governmentBenefits, setPowerOfAttorney, navigate ]);
  
  return (
    <div className="new-poa-government-benefits screen-container screen">
      <ScreenHeader
        title="Government Benefits"
        description="Decide whether to grant your agent power to manage government benefits"
        handleBack={handleBack}
      />
      
      <div className="content-section">
        <h3>What Are Government Benefit Powers?</h3>
        <p>
          Government benefit powers allow your agent to manage your government 
          benefits and assistance programs. This includes:
        </p>
        <ul className="government-benefits-list">
          <li>Social Security benefits and applications</li>
          <li>Medicare and Medicaid benefits</li>
          <li>Veterans Affairs benefits</li>
          <li>Disability benefits and appeals</li>
          <li>Unemployment benefits</li>
          <li>Food assistance and housing programs</li>
          <li>Other federal and state benefit programs</li>
        </ul>

        <h3>What Your Agent Can Do</h3>
        <p>If you grant this power, your agent can:</p>
        <ul className="agent-powers">
          <li>Apply for government benefits on your behalf</li>
          <li>Receive and manage benefit payments</li>
          <li>Appeal benefit decisions</li>
          <li>Communicate with government agencies</li>
          <li>Complete required forms and applications</li>
          <li>Represent you in benefit matters</li>
        </ul>

        <h3>Do You Want to Grant This Power?</h3>
        <div className="asset-distribution-option-container">
          <AssetDistributionOption
            id="government-benefits-yes"
            label="Yes"
            description="Grant power to manage government benefits"
            value="yes"
          />
          <AssetDistributionOption
            id="government-benefits-no"
            label="No"
            description="Do not grant power to manage government benefits"
            value="no"
          />
        </div>

        <div className="important-note">
          <h4>Important:</h4>
          <p>
            Some government agencies may require separate representative payee 
            applications or specific authorization forms. Your power of attorney 
            may need to be supplemented with agency-specific documents.
          </p>
        </div>
      </div>

      <ButtonBar 
        handlePrimary={handleNext}
        primaryText="Continue"
      />
    </div>
  );
}
